import React from 'react';
import { HtmlTable } from '../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { WorkflowComponentProps } from '../../../../Workflow/Workflow.meta';
import { ColumnHeader } from '../../../OtherAssets/OtherAssets.meta';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { useIsPdf } from '../../../../FinancialPlanOPL/hooks/useIsPdf';
import { PDFSafeTableHeaderCaption } from '../../../../CommonComponents/OPL/HtmlTable/components/PDFSafeTableHeaderCaption/PDFSafeTableHeaderCaption';

interface Props {
  title: string;
  isEmpty: boolean;
  columnHeaders: ColumnHeader[];
  children: React.ReactNode;
  onAddInsurance(): void;
  workflowProps?: WorkflowComponentProps;
}

export const InsuranceTable = ({
  title,
  isEmpty,
  columnHeaders,
  children,
  onAddInsurance,
  workflowProps,
}: Props) => {
  const isPrint = useIsPdf();

  return (
    <HtmlTable variant={workflowProps && 'bordered'}>
      <table>
        <thead>
          <PDFSafeTableHeaderCaption
            colSpan={isPrint ? columnHeaders.length : columnHeaders.length + 1}
          >
            {title}
          </PDFSafeTableHeaderCaption>
          {!isEmpty && (
            <tr>
              {columnHeaders.map(({ text, align }) => (
                <th key={text} style={{ whiteSpace: 'unset' }}>
                  <Text variant="smallCaps" textAlign={align || 'left'}>
                    {text}
                  </Text>
                </th>
              ))}

              {!isPrint && <th aria-label={`Actions for ${title}`}>&nbsp;</th>}
            </tr>
          )}
        </thead>

        <tbody>
          {isEmpty ? (
            <>
              {isPrint ? (
                <tr>
                  <td colSpan={5}>
                    <Text fontWeight={500}>No Insurance available.</Text>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan={columnHeaders.length}>
                    <Button leftIcon="fas fa-plus" variant="link" onClick={onAddInsurance}>
                      Add Insurance
                    </Button>
                  </td>
                </tr>
              )}
            </>
          ) : (
            children
          )}
        </tbody>
      </table>
    </HtmlTable>
  );
};
